import React from 'react';
import { useSite } from '../useSite';

// Licensed stock (Unsplash License / Pexels License); people shown are not Bullish clients or staff.
export const PHOTOS = {
  'miami-hero': { w: 2000, h: 3000, en: 'Palm tree beside a white modern building in Miami', es: 'Palmera junto a un edificio blanco moderno en Miami' },
  residence: { w: 2000, h: 1333, en: 'Contemporary residence surrounded by palm trees', es: 'Residencia contemporánea rodeada de palmeras' },
  entrepreneur: { w: 2000, h: 3000, en: 'Entrepreneur working at a desk in a sunlit studio', es: 'Emprendedora trabajando en un estudio iluminado por el sol' },
  meeting: { w: 2000, h: 1125, en: 'Professionals meeting around a table in a warm modern office', es: 'Profesionales reunidos en una oficina moderna y cálida' },
  'advisory-desk': { w: 2000, h: 2500, en: 'Fountain pen resting on an open notebook', es: 'Pluma estilográfica sobre un cuaderno abierto' },
  skyline: { w: 2000, h: 1125, en: 'Miami skyline across the bay', es: 'Horizonte de Miami sobre la bahía' },
  office: { w: 2000, h: 3000, en: 'Refined office with wooden shelving and a meeting table', es: 'Oficina refinada con estanterías de madera y mesa de reuniones' },
};

export const Photo = ({ name, className = '', sizes = '(min-width: 1024px) 50vw, 100vw', eager = false, testId }) => {
  const { lang } = useSite();
  const meta = PHOTOS[name];
  return (
    <img
      src={`/images/${name}-1024.webp`}
      srcSet={[640, 1024, 1600].map((w) => `/images/${name}-${w}.webp ${w}w`).join(', ')}
      sizes={sizes}
      alt={meta[lang]}
      width={meta.w}
      height={meta.h}
      loading={eager ? 'eager' : 'lazy'}
      fetchPriority={eager ? 'high' : undefined}
      decoding="async"
      data-testid={testId || `photo-${name}`}
      className={`h-full w-full object-cover ${className}`}
    />
  );
};
